// extracted by mini-css-extract-plugin
module.exports = {"container":"textStack_container__WWnB2","emptyStack":"textStack_emptyStack__w11bz","collapsed":"textStack_collapsed__z9aJ_"};